(function () {
  const EXPAND_TEXT = 'Read more';
  const COLLAPSE_TEXT = 'Read less';
  const MQ_MOBILE = window.matchMedia('(max-width: 767px)');

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('.heading-description-wrap').forEach(setupOne);
  }

  function setupOne(wrap) {
    if (wrap.dataset.toggleBound === '1') return;
    const desc = wrap.querySelector('.heading-description');
    if (!desc) return;
    wrap.dataset.toggleBound = '1';

    let btn = wrap.querySelector('.desc-toggle-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'desc-toggle-btn';
      btn.hidden = true;
      wrap.appendChild(btn);
    }

    const apply = () => {
      if (!MQ_MOBILE.matches) {
        wrap.classList.remove('is-clampable', 'is-expanded');
        btn.hidden = true;
        return;
      }
      wrap.classList.add('is-clampable');
      wrap.classList.remove('is-expanded');

      requestAnimationFrame(() => {
        const overflow = wrap.scrollHeight > wrap.clientHeight + 1;
        if (!overflow) {
          wrap.classList.remove('is-clampable');
          btn.hidden = true;
          return;
        }
        btn.hidden = false;
        btn.textContent = EXPAND_TEXT;
      });
    };

    btn.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('is-expanded');
      btn.textContent = expanded ? COLLAPSE_TEXT : EXPAND_TEXT;
    });

    if (MQ_MOBILE.addEventListener) {
      MQ_MOBILE.addEventListener('change', apply);
    } else {
      MQ_MOBILE.addListener(apply);
    }

    apply();
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();